import { MyIncidents } from "@/features/home/my-incidents";

export const Route = createFileRoute({
  component: MyIncidents,
});
